module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hant_okinawa-a3737c937a4ad25b475242c3ec3b1b95.jpg";